<template>
  <div class="mem4-lightbox grid">
    <!--  gallery list  -->
    <div
      v-for="(image, index) in media"
      :key="index"
      class="grid__col grid__col4-desktop grid__col4-tablet grid__col6 mem4-lightbox__media"
      :data-id="image.id ? image.id : ''"
    >
      <img :src="image.thumb" @click="openGallery(index)" class="mem4-lightbox__media__thumb-img" />
      <div v-if="image.thumbCaption" class="mem4-lightbox__media__thumb-caption">
        <span v-html="image.thumbCaption"></span>
      </div>
    </div>
    <!--  light box modal  -->
    <Transition name="fade">
      <div v-if="openedModal" class="mem4-lightbox__modal">
        <div class="mem4-lightbox__modal__content">
          <TransitionGroup name="image">
            <img :key="currImage.src" :src="currImage.src" alt="" class="mem4-lightbox__modal__content__img" />
          </TransitionGroup>
        </div>
        <div class="mem4-lightbox__modal__footer">
          <div><span v-html="currImage.caption"></span></div>
          <div class="mem4-lightbox__modal__footer__count">{{ counter }}</div>
        </div>
        <button @click="closeGallery" type="button" title="Close" class="mem4-lightbox__modal__close">
          <m4-icon icon="close-alt"></m4-icon>
        </button>
        <button @click="prevImage" type="button" title="Previous" class="mem4-lightbox__modal__arrow-left">
          <m4-icon icon="angle-left-alt"></m4-icon>
        </button>
        <button @click="nextImage" type="button" title="Next" class="mem4-lightbox__modal__arrow-right">
          <m4-icon icon="angle-right-alt"></m4-icon>
        </button>
      </div>
    </Transition>
  </div>
</template>

<script>
export default {
  name: "M4LightBox",
  data() {
    return {
      openedModal: false,
      currImageIndex: null
    };
  },
  props: {
    media: Array
  },
  computed: {
    currImage() {
      if (this.currImageIndex !== null && this.media[this.currImageIndex] !== undefined) {
        return this.media[this.currImageIndex];
      }
      return null;
    },
    counter() {
      return this.currImageIndex + 1 + "/" + this.mediaLength;
    },
    mediaLength() {
      return this.media.length;
    }
  },
  methods: {
    openGallery(index) {
      this.openedModal = true;
      this.currImageIndex = index;
    },
    closeGallery() {
      this.openedModal = false;
    },
    prevImage() {
      if (this.currImageIndex > 0 && this.currImageIndex < this.mediaLength) {
        this.currImageIndex--;
      } else {
        this.currImageIndex = this.mediaLength - 1;
      }
    },
    nextImage() {
      if (this.currImageIndex + 1 < this.mediaLength) {
        this.currImageIndex++;
      } else {
        this.currImageIndex = 0;
      }
    }
  }
};
</script>
